import React from 'react';
import PropTypes from 'prop-types';
import { isEqual, isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import FilterRange from '../FilterRange/FilterRange.jsx';
import FilterRangeService from '../FilterRange/FilterRangeService/FilterRangeService.js';

import { DEFAULT_STEP, DEFAULT_MIN, DEFAULT_MAX, URL_PARAMETER_MIN, URL_PARAMETER_MAX } from './constants.js';

class ListingFiltersOdometer extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelectedValue = this.handleSelectedValue.bind(this);
        this.updateQuery = this.updateQuery.bind(this);

        this.state = FilterRangeService.getInitState({
            metadataCategorie: props.odometers,
            URL_PARAMETER_MIN,
            URL_PARAMETER_MAX,
            DEFAULT_MIN,
            DEFAULT_MAX,
            DEFAULT_STEP,
        });
    }

    componentWillReceiveProps(nextProps) {
        const propsExtremeValues = FilterRangeService.getExtremeValues(this.props.odometers);
        const nextPropsExtremeValues = FilterRangeService.getExtremeValues(nextProps.odometers);

        // Update the state only if the props of extremeValues has changed.
        if (!isEqual(propsExtremeValues, nextPropsExtremeValues) || isEmpty(nextProps.odometerRange)) {
            const initState = FilterRangeService.getInitState({
                metadataCategorie: nextProps.odometers,
                URL_PARAMETER_MIN,
                URL_PARAMETER_MAX,
                DEFAULT_MIN,
                DEFAULT_MAX,
                DEFAULT_STEP,
            });
            this.setState(initState);
        }
    }

    getLabels(selectedMin, selectedMax, extremeMin, extremeMax) {
        const labelMin = selectedMin <= extremeMin ? `<${DEFAULT_STEP}` : selectedMin.toString();
        const labelMax = selectedMax >= extremeMax ? LocaleService.t('MILEAGE.MAXIMUM') : selectedMax.toString();

        return {
            labelMin,
            labelMax,
        };
    }

    handleSelectedValue(selectedMin, selectedMax) {
        this.setState({
            selectedMin,
            selectedMax,
        });
    }

    updateQuery(selectedMin, selectedMax) {
        this.props.updateVehicleCriteria(
            {
                type: 'CLOSED',
                from: selectedMin,
                to: selectedMax,
            },
            'odometerRange',
            true
        );
    }

    render() {
        const { labelMin, labelMax } = this.getLabels(
            this.state.selectedMin,
            this.state.selectedMax,
            this.state.extremeMin,
            this.state.extremeMax
        );

        const title = `${LocaleService.t('FILTERS.ODOMETER')} ${LocaleService.t('MILEAGE.KM')}`;

        if (!this.props.isUsed) {
            return null;
        }

        return (
            <FilterRange
                title={title}
                extremeMin={this.state.extremeMin}
                extremeMax={this.state.extremeMax}
                defaultMin={this.state.selectedMin}
                defaultMax={this.state.selectedMax}
                step={DEFAULT_STEP}
                labelMin={labelMin}
                labelMax={labelMax}
                updateQuery={this.updateQuery}
                handleSelectedValue={this.handleSelectedValue}
            />
        );
    }
}

ListingFiltersOdometer.defaultProps = {
    odometers: [],
    odometerRange: {},
    isUsed: true,
};

ListingFiltersOdometer.propTypes = {
    odometers: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)), // eslint-disable-line react/no-unused-prop-types
    odometerRange: PropTypes.object,
    updateVehicleCriteria: PropTypes.func.isRequired,
    isUsed: PropTypes.bool,
};

ListingFiltersOdometer.displayName = 'ListingFiltersOdometer';

export default ListingFiltersOdometer;
